export interface MailSettings {
  companyId?: number;
  smtpHost?: string | null;
  smtpPort?: number;
  smtpAuth?: boolean;
  smtpSsl?: boolean;
  smtpTls?: boolean;
  smtpVerifyHostCert?: boolean;
  active?: boolean;
  fromEmail?: string | null;
  fromName?: string | null;
  username?: string | null;
  hasStoredPassword?: boolean;
  configured?: boolean;
}

export interface MailSettingsFormData {
  smtpHost: string;
  smtpPort: number;
  smtpAuth: boolean;
  smtpSsl: boolean;
  smtpTls: boolean;
  smtpVerifyHostCert: boolean;
  active: boolean;
  fromEmail: string;
  fromName: string;
  username: string;
  password: string;
}

export interface MailSettingsRequest {
  smtpHost: string;
  smtpPort: number;
  smtpAuth: boolean;
  smtpSsl: boolean;
  smtpTls: boolean;
  smtpVerifyHostCert: boolean;
  active: boolean;
  fromEmail: string;
  fromName: string;
  username: string;
  password?: string;
}

export interface MailTestSendResponse {
  success: boolean;
  message: string;
}

export const emptyMailSettingsFormData: MailSettingsFormData = {
  smtpHost: '',
  smtpPort: 587,
  smtpAuth: true,
  smtpSsl: false,
  smtpTls: true,
  smtpVerifyHostCert: true,
  active: true,
  fromEmail: '',
  fromName: '',
  username: '',
  password: '',
};

export const mapMailSettingsToFormData = (settings?: MailSettings): MailSettingsFormData => ({
  smtpHost: settings?.smtpHost ?? '',
  smtpPort: settings?.smtpPort ?? 587,
  smtpAuth: settings?.smtpAuth ?? true,
  smtpSsl: settings?.smtpSsl ?? false,
  smtpTls: settings?.smtpTls ?? true,
  smtpVerifyHostCert: settings?.smtpVerifyHostCert ?? true,
  active: settings?.active ?? true,
  fromEmail: settings?.fromEmail ?? '',
  fromName: settings?.fromName ?? '',
  username: settings?.username ?? '',
  password: '',
});
